import React, { useEffect } from "react";
import moment from "moment";
import CategoryPolls from "../../components/CategoryPolls/CategoryPolls";
import PreSectionHeader from "../../components/PreSectionHeader/PreSectionHeader";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { pickforyouData } from "../../redux/actions/publicAction";

const PickForYou = () => {
  const dispatch = useDispatch();
  const { pickforyou } = useSelector((state) => state.publicReducer);
  const isVerified = localStorage.getItem("accessToken");
  const breadCumb = [
    { id: 1, name: isVerified ? "For You " : "News ", link: "/" },
    {
      id: 2,
      name: "Picks For You",
      link: "/picks-for-you",
    },
  ];

  useEffect(() => {
    dispatch(pickforyouData());
  }, []);
  const createSlug = (title) =>
    title
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  function cleanString(str) {
    return str.replace(/[^a-zA-Z0-9-_]/g, "");
  }

  return (
    <div className="bg_home bg-[#F7F8FA] md:bg-[#ffffff] flex flex-col ">
      <div className="">
        <div className="md:hidden my-4 px-4">
          {" "}
          <PreSectionHeader title={"Pick For You"} />
        </div>
        <hr className="border-b-1 md:border-none mt-3 md:mt-0 font-semibold" />

        {/* Web view: Display all stories */}
        <div className="bg_home md:bg-[#F7F8FA]  px-0 min-[840px]:px-40 flex flex-col min-[840px]:pb-14 md:py-0">
          <div className="flex flex-row items-center py-5">
            {breadCumb.map((item, index) => (
              <span
                key={item.id}
                className={`text-[10px] font-medium  ${
                  index === breadCumb.length - 1 ? "" : "opacity-60"
                }`}
              >
                {index > 0 && <span className="mx-1">&gt;</span>}
                <Link to={item?.link} className="breadcrumb-link">
                  {item.name}
                </Link>
              </span>
            ))}
          </div>
          <div className="md:bg-[#FFFFFF] w-full   rounded-lg ">
            <div className="bg-white w-full  p-3 md:p-5  rounded-lg">
              {/* <SecHead title={"Top Stories"} redirectLink="/top-stories" /> */}
              <h3 className="flex font-sans text-[21px] leading-[20px] font-semibold tracking-normal text-[#1A1A1A] hidden md:block">
                Picks For You
              </h3>
              <div className=" ">
                {Array.isArray(pickforyou) &&
                  pickforyou.map((post) =>  {
                          const categorySlug = createSlug(post?.category?.name);
                          return (
                    // console.log(post, "post", post?.file?.[0]?.url),
                    <Link
                      // to={`/top-story-details/${post?.uuid}`}
                      to={`/${categorySlug}/general-stories/${post?.slug}`}
                      key={post?.id}
                      className="flex flex-col md:flex-row items-start gap-5 py-4  relative"
                    >
                      <img
                        src={post?.file}
                        alt={post?.fileId}
                        className="w-full md:w-[14rem] h-36  object-cover rounded-md"
                      />
                      <div className="flex flex-col gap-1">
                        <CategoryPolls
                          key={post?.category?.id}
                          title={post?.category?.name}
                          postid={post?.category?.id}
                          img={post?.category?.icon}
                        />
                        <span
                          className=" text-[#1A1A1A] open-sans-600  tracking-tight"
                          style={{ lineHeight: 1.4 }}
                        >
                          {post?.title}
                        </span>
                        {/* <span
                          className="text-[#7F8FA4] black-heading text-manage font-normal text-xs leading-[18px] font-open-sans tracking-normal text-custom-gray text-left"
                          dangerouslySetInnerHTML={{
                            __html: post?.description,
                          }}
                        >
                          
                        </span> */}
                        <span className=" date_shown relative md:absolute md:bottom-3">
                          {moment(post?.updatedAt).format("MMMM D, YYYY")}
                        </span>
                      </div>
                    </Link>
                  );})}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PickForYou;
